export default "__VITE_ASSET__CI9YfVQi__"